<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <mt-header title>
          <router-link to slot="left">
            <mt-button icon="back" @click.native="$router.back(-1)"
              >资质认证</mt-button
            >
          </router-link>
        </mt-header>
        <div class="warning">请您填写真实信息</div>
        <div class="form">
          <div class="rolItem">
            <!-- 主专业 -->
            <mt-field label="亚专业(主)：" class="inputStyle" disabled>
              <span @click="getCerSpeciality">{{
                user.cerSpeciality || '请选择亚专业(主)'
              }}</span>
            </mt-field>
            <mt-popup
              v-model="cerSpecialityShow"
              position="bottom"
              popup-transition="popup-fade"
              fixed
            >
              <div @click="getCerSpeciality" class="showPopup">完成</div>
              <mt-picker
                :slots="dataSlots"
                :visibleItemCount="5"
                valueKey="name"
                @change="onCerSpecialityChange"
              ></mt-picker>
            </mt-popup>
            <!-- 亚专业 -->
            <mt-field label="亚专业(副)：" class="inputStyle" disabled>
              <span @click="getOtherSpeciality">{{
                user.cerOtherSpeciality || '请选择亚专业(副)'
              }}</span>
            </mt-field>
            <mt-popup
              style="height: 50%; overflow: auto"
              min-height="100vh"
              v-model="cerOtherSpecialityShow"
              position="bottom"
              popup-transition="popup-fade"
              fixed
            >
              <div @click="getOtherSpeciality" class="showPopup">完成</div>
              <mt-checklist
                v-model="value"
                :options="options"
                @change="checkon($event)"
              ></mt-checklist>
            </mt-popup>
            <mt-field
              label="职称："
              class="inputTxt"
              type="text"
              v-model="user.cerJob"
              placeholder="请输入职称"
              @change="remarkShow"
            ></mt-field>
          </div>
          <div class="rolItem">
            <mt-field
              label="职业证书："
              accept="application/msword, application/pdf"
              class="inputStyle"
              disabled
            ></mt-field>
          </div>
          <div>
            <Upload v-on:input="formUrl" class="upload" />
          </div>
          <ul class="img-list">
            <li
              class="show-img"
              v-for="(item, index) in certificateUrlList"
              :key="index"
            >
              <img :src="item" class="imgs" />
              <span class="isDel" @click="delImg(index)">
                <img src="../../assets/img/delete_x.png" alt />
                <!-- X -->
              </span>
            </li>
          </ul>
        </div>
        <p
          v-if="remarkDisabled"
          class="cerType"
          :class="{ red: user.isAuth === 3 }"
        >
          {{
            user.isAuth === 2
              ? '认证已通过'
              : user.isAuth === 3
              ? '认证信息被驳回：' + user.remark
              : ''
          }}
        </p>
        <div class="getBtn">
          <mt-button
            type="primary"
            class="btn"
            @click="getQualification"
            :disabled="user.isAuth === 1"
            >{{
              user.isAuth === 2 || user.isAuth === 3
                ? '重新认证'
                : user.isAuth === 1
                ? '认证中'
                : '提交认证'
            }}</mt-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { refreshToken } from '../../common/refreshToken'
import Upload from '../../components/Upload'
export default {
  components: { Upload },
  data() {
    return {
      remarkDisabled: true,
      user: {
        cerJob: '',
        certificateUrl: '',
        cerOtherSpeciality: '',
        cerSpeciality: '',
        isAuth: 0
      },
      certificateUrlList: [],
      commitType: true,
      openId: '',
      cerLevelShow: false,
      cerSpecialityShow: false,
      cerOtherSpecialityShow: false,
      // 主专业选择
      dataSlots: [
        {
          flex: 1,
          values: []
        }
      ],
      value: [],
      // 亚专业选择
      options: [],
      cer: ''
    }
  },
  mounted() {
    refreshToken(this).then(res => {
      if (res.code == 0) {
        this.user = JSON.parse(sessionStorage.getItem('userInfo'))
      }
    })
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    this.getUser()
    this.getCerSpecialityList()
    this.noShare()
  },
  methods: {
    remarkShow() {
      this.remarkDisabled = false
    },
    noShare() {
      let _this = this
      if (typeof WeixinJSBridge == 'undefined') {
        //微信浏览器内置对象。参考微信官方文档
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            _this.onBridgeReady(),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady())
          document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady())
        }
      } else {
        _this.onBridgeReady()
      }
    },
    onBridgeReady: function() {
      WeixinJSBridge.call('hideOptionMenu')
    },
    getCerLevel() {
      this.cerLevelShow = !this.cerLevelShow
    },
    getCerSpeciality() {
      this.user.cerSpeciality = this.cer
      this.cerSpecialityShow = !this.cerSpecialityShow
      this.remarkDisabled = false
    },
    getOtherSpeciality() {
      this.cerOtherSpecialityShow = !this.cerOtherSpecialityShow
    },
    // 亚专业值改变
    checkon(item) {
      this.user.cerOtherSpeciality = item.join(',')
      this.remarkDisabled = false
    },
    // 主专业改变
    onCerSpecialityChange(picker, values) {
      if (values[0]) {
        this.cer = values[0].name
      }
      if (this.cerSpecialityShow) {
        if (values[0]) {
          this.user.cerSpeciality = values[0].name
        }
      }
    },
    formUrl(certificateUrl) {
      if (
        this.user.certificateUrl !== null &&
        this.user.certificateUrl.length > 0 &&
        certificateUrl !== ''
      ) {
        this.remarkDisabled = false
        this.user.certificateUrl =
          certificateUrl + ',' + this.user.certificateUrl
      } else {
        this.user.certificateUrl = certificateUrl
      }
    },
    // 获取职级表
    getCerSpecialityList() {
      this.$http({
        url: '/live/userMajor/list',
        method: 'post',
        params: { page: 1, limit: 100 }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataSlots[0].values = data.data.list
          const list = data.data.list
          for (var i = 0; i < list.length; i++) {
            const obj = { label: list[i].name, value: list[i].name }
            this.options.push(obj)
          }
        } else {
          this.CerSpecialityList = []
        }
      })
    },
    // 获取用户信息
    getUser() {
      if (this.user) {
        if (
          this.user.certificateUrl !== undefined &&
          this.user.certificateUrl !== null
        ) {
          this.certificateUrlList = this.user.certificateUrl.split(',')
        }
        if (this.user.certificateUrl === '') {
          this.certificateUrlList = []
        }
      } else {
        this.user = {}
        this.certificateUrlList = []
      }
    },
    delImg(index) {
      if (this.user.isAuth === 1) {
        return this
      }
      this.certificateUrlList.splice(index, 1)
      if (this.certificateUrlList.length > 0) {
        this.user.certificateUrl = this.certificateUrlList.join(',')
      } else {
        this.user.certificateUrl = ''
      }
    },
    // 不为空判断
    judgeParams() {
      const _this = this
      if (!_this.user.cerSpeciality) {
        _this.$messagebox.alert('主专业(主)不能为空')
        _this.commitType = false
      }

      if (!_this.user.cerJob) {
        _this.$messagebox.alert('职称不能为空')
        _this.commitType = false
      }

      if (!_this.user.certificateUrl) {
        _this.$messagebox.alert('职业证书不能为空')
        _this.commitType = false
      }
    },
    // 提交认证信息
    getQualification() {
      this.commitType = true
      this.judgeParams()
      if (!this.commitType) {
        return this
      }
      const openId = sessionStorage.getItem('openId')
      this.$http({
        url: '/live/liveUsers/updateInfo',
        method: 'put',
        data: {
          openId: openId,
          cerSpeciality: this.user.cerSpeciality,
          cerOtherSpeciality: this.user.cerOtherSpeciality,
          cerJob: this.user.cerJob,
          certificateUrl: this.user.certificateUrl,
          isAuth: 1
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$toast('认证信息已提交')
          refreshToken(this).then(res => {
            if (res.code == 0) {
              // this.$router.push('/personal')
              const routeData = this.$router.resolve({
                path: '/personal'
                // query: { liveId: liveId }
              })
              window.open(routeData.href, '_blank')
            }
          })
        } else {
          this.$toast('认证信息提交失败，请稍后再试')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.showPopup {
  text-align: right;
  margin-right: 1rem;
  padding: 1rem 0;
  font-size: 18px;
}
/deep/ .mint-popup-bottom {
  width: 100%;
}
.rolItem {
  background-color: #eee;
  padding-bottom: 1rem;
}
.getBtn {
  box-sizing: border-box;
  margin-top: 20px;
  height: 55px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.btn {
  width: 90%;
  height: 100%;
  font-size: $font-title;
  border-radius: 10px;
  color: #fff;
  line-height: 36px;
}
.btn:hover {
  color: #fff;
  text-decoration: none;
  border: none;
}
.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none;
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0.3rem 0.3rem 0;
  li {
    position: relative;
    margin: 1rem;
    width: 100%;
    .imgs {
      width: 100%;
    }
    span {
      margin: 1rem;
      position: absolute;
      border-radius: 50%;
      top: 0;
      right: 0;
      width: 2rem;
      height: 2rem;
      // background-color: #eee;
      opacity: 0.7;
      text-align: center;
      img {
        border-radius: 50%;
        width: 100%;
      }
    }
  }
}
.showImg {
  padding: 1rem;
  img {
    width: 100%;
  }
}
.cerType {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem 1rem;
  line-height: 2rem;
  color: green;
}
.red {
  color: #f00;
}
.inputStyle /deep/ .mint-field-core {
  flex: 0;
  padding: 0;
  width: 0;
}
.job {
  width: 150px;
  height: 100%;
  padding: 1rem;
  border: 0;
  background-color: #eee;
  option {
    border: 0;
    width: 150px;
  }
}
.container {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
}
.warning {
  text-align: center;
  padding: 1rem;
  background-color: #eee;
}
</style>
